export default [
  { short: 'Idanto', long: 'Idanto Corelli', id: 1 },
  { short: 'Jondras', long: 'Jondras Bran', id: 2 },
  { short: 'Laetitia', long: 'Lateitia Ferea', id: 3 },
  { short: 'Nahima', long: 'Nahima Saba Ashun', id: 4 },
  { short: 'Richard', long: 'Richard von Forsting', id: 5 },
  { short: 'Dante', long: 'Dante', id: 6 },
];
